import { render, staticRenderFns } from "./FormDivider.vue?vue&type=template&id=3c15b2ff&scoped=true"
import script from "./FormDivider.vue?vue&type=script&lang=js"
export * from "./FormDivider.vue?vue&type=script&lang=js"
import style0 from "./FormDivider.vue?vue&type=style&index=0&id=3c15b2ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c15b2ff",
  null
  
)

export default component.exports